<template>
  <div>
    <br>
    <b-container>
      <h1 class="text-center">Thorough Mold Inspections &amp; Remediation</h1>
      <hr>
      <p>Controlling the moisture in your environment is the key to successful mold and mildew remediation. Call on Commonwealth Moisture &amp; Mold Specialists for mold inspections.</p>
      <b-row>
        <b-col sm="3">
          <b-img fluid src="/housedoctor.png"></b-img>
        </b-col>
        <b-col>
          <h2>The Problem with Mold &amp; Mildew</h2>
          <p>Mold and mildew cause a damp, musty smell created by fungi that thrive in moist conditions. Mold can also cause health concerns, including irritation. The odor mold produces as it degrades organic substances can irritate mucus membranes, leading to itchy, watery eyes, headaches, and other symptoms. Mold spores can also create discomfort for allergy sufferers with some people experiencing allergic reactions. How your health is affected by mold is dependent on the amount of exposure and your individual susceptibility. People most vulnerable include:</p>
          <b-table :items="items"></b-table>
        </b-col>
      </b-row>
      <h2>Solving the Problem</h2>
      <p>Treating existing mold and removing moisture is key to reducing the chance for mold to grow. We at Commonwealth Moisture &amp; Mold Specialists are trained professionals who know how to remove mold and eliminate its chances of survival. We are American IAQ Council-certified mold inspectors and mold remediators.</p>
      <h2>Mold Sampling &amp; Testing</h2>
      <p>Mold samples are collected as needed to confirm or deny the hypothesis of fungal ecology. We use a variety of collection devices including swab, bulk, Allergenco D Posi-Track™ spore traps, and Auger plates. The type of collection will depend on the results needed. Samples can be cultured to determine the species or just counted to determine the fungal load. All samples are analyzed by qualified laboratories to eliminate any conflict of interest.</p>
    </b-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      items: [
        {one: 'People with allergies', two: 'Infants & Children'},
        {one: 'Asthmatics', two: 'People with Existing Respiratory Problems'},
        {one: 'Seniors & Elderly', two: 'Individuals with Weakened Immune Systems'}
      ]
    }
  }
}
</script>

<style>
thead {
  display: none;
}
</style>
